module.exports = __webpack_public_path__ + "img/_akaCube.c35b4ba8.png";